import React, { useState } from 'react';
import { EditIcon, KeyIcon, TrashIcon } from 'lucide-react';
import { EditProfileModal } from './modals/EditProfileModal';
import { ChangePasswordModal } from './modals/ChangePasswordModal';
import { DeleteAccountModal } from './modals/DeleteAccountModal';
export function LoginSecuritySection() {
  const [editProfileOpen, setEditProfileOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
  const userInfo = {
    name: 'Ahmed Mohammed',
    email: 'ahmed.mohammed@example.com',
    phone: '+966 50 123 4567',
    gender: 'Male',
    maritalStatus: 'Married',
    nationality: 'Saudi Arabian',
    dateOfBirth: '1990-05-15',
    workingSector: 'Healthcare',
    city: 'Riyadh',
    district: 'Al Olaya',
    preferredLanguage: 'English'
  };
  return <div className="space-y-6" data-id="element-396" data-mp="2ackuwlz7lbvk">
      {/* Personal Information */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5" data-id="element-397" data-mp="2acb5azi2t6qe">
        <div className="flex items-center justify-between mb-6" data-id="element-398" data-mp="341f3hf10dccn">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-399" data-mp="390rn7qwl23b0">
            Personal Information
          </h2>
          <button onClick={() => setEditProfileOpen(true)} className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#1E2B55] hover:bg-blue-50 rounded-lg transition-colors" data-id="element-400" data-mp="3drrk4w5pcldi">
            <EditIcon className="w-4 h-4" data-id="element-401" data-mp="2l4nld8x7d3a6" />
            Edit
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-402" data-mp="2q3gt0kpt602f">
          <div data-id="element-403" data-mp="2u4ac90sb2qoz">
            <label className="text-sm text-gray-600" data-id="element-404" data-mp="2u3r6eifxjsrb">Full Name</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-405" data-mp="2z33royr5krrs">
              {userInfo.name}
            </p>
          </div>
          <div data-id="element-406" data-mp="9ekykr3c9axv">
            <label className="text-sm text-gray-600" data-id="element-407" data-mp="9d04f2kxru0j">Email Address</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-408" data-mp="ecd0mdxp6dfs">
              {userInfo.email}
            </p>
          </div>
          <div data-id="element-409" data-mp="2aeq0ctubzg4t">
            <label className="text-sm text-gray-600" data-id="element-410" data-mp="2ae7ud5hv9njp">Phone Number</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-411" data-mp="26dnuvv9tm7ue">
              {userInfo.phone}
            </p>
          </div>
          <div data-id="element-412" data-mp="2kc4c4g5b7gqs">
            <label className="text-sm text-gray-600" data-id="element-413" data-mp="2ff4788k74k19">Gender</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-414" data-mp="2ffngz1zp0247">
              {userInfo.gender}
            </p>
          </div>
          <div data-id="element-415" data-mp="1mqggvyklb4gu">
            <label className="text-sm text-gray-600" data-id="element-416" data-mp="1mqylbiheoozu">Marital Status</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-417" data-mp="1moluefto74an">
              {userInfo.maritalStatus}
            </p>
          </div>
          <div data-id="element-418" data-mp="1wocmybyo7983">
            <label className="text-sm text-gray-600" data-id="element-419" data-mp="1wnuln0x5i4tb">Nationality</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-420" data-mp="18yiavwm6doow">
              {userInfo.nationality}
            </p>
          </div>
          <div data-id="element-421" data-mp="13zfibbndtaxt">
            <label className="text-sm text-gray-600" data-id="element-422" data-mp="13xupprkmo22l">Date of Birth</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-423" data-mp="3fmiss05owzej">
              {new Date(userInfo.dateOfBirth).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
          </div>
          <div data-id="element-424" data-mp="3ap90mcqx29n0">
            <label className="text-sm text-gray-600" data-id="element-425" data-mp="3aoqw6su3op40">Working Sector</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-426" data-mp="29h0q3kpui57">
              {userInfo.workingSector}
            </p>
          </div>
          <div data-id="element-427" data-mp="75ego8s2hmhg">
            <label className="text-sm text-gray-600" data-id="element-428" data-mp="3pd3y06fvd26f">City</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-429" data-mp="3pclqgdnrb1j7">
              {userInfo.city}
            </p>
          </div>
          <div data-id="element-430" data-mp="3ue1b44m0v612">
            <label className="text-sm text-gray-600" data-id="element-431" data-mp="2dy87nn7v1ca1">District</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-432" data-mp="2e01htchomems">
              {userInfo.district}
            </p>
          </div>
          <div data-id="element-433" data-mp="2y782gry4gqeg">
            <label className="text-sm text-gray-600" data-id="element-434" data-mp="2y6yetb0juvbx">Preferred Language</label>
            <p className="text-base font-medium text-gray-900 mt-1" data-id="element-435" data-mp="2tg837g1j5w8s">
              {userInfo.preferredLanguage}
            </p>
          </div>
        </div>
      </div>
      {/* Password & Security */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5" data-id="element-436" data-mp="2kftjum84mr7x">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-437" data-mp="3h5kbmdp1a0a1">
          Password & Security
        </h2>
        <div className="space-y-4" data-id="element-438" data-mp="3c6pk8nd033eb">
          {/* Password */}
          <div className="flex items-center justify-between py-3" data-id="element-439" data-mp="3c791e1uttnra">
            <div className="flex items-center gap-3" data-id="element-440" data-mp="383ta7l1j0flz">
              <KeyIcon className="w-5 h-5 text-gray-400" data-id="element-441" data-mp="335rqcxwa0c9g" />
              <div data-id="element-442" data-mp="3359l5brmynpe">
                <p className="font-medium text-gray-900" data-id="element-443" data-mp="337vspbej137m">Password</p>
                <p className="text-sm text-gray-600" data-id="element-444" data-mp="1wqh1avqwt6sy">••••••••</p>
              </div>
            </div>
            <button onClick={() => setChangePasswordOpen(true)} className="text-sm font-medium text-[#1E2B55] hover:underline" data-id="element-445" data-mp="1rptd0hu2f42f">
              Change
            </button>
          </div>
        </div>
      </div>
      {/* Delete Account */}
      <div className="bg-white rounded-xl border border-red-200 shadow-sm p-5" data-id="element-446" data-mp="g904hs37kni1">
        <div className="flex items-start gap-3" data-id="element-447" data-mp="kzqcze6xl6gy">
          <TrashIcon className="w-5 h-5 text-red-600 mt-0.5" data-id="element-448" data-mp="l1ji2p1wbimu" />
          <div className="flex-1" data-id="element-449" data-mp="pzusp200lx64">
            <h3 className="font-bold text-gray-900 mb-1" data-id="element-450" data-mp="pyjstd9ox9ka">Delete Account</h3>
            <p className="text-sm text-gray-600 mb-4" data-id="element-451" data-mp="ux3edckdgjc4">
              Permanently delete your account and all associated data. This
              action cannot be undone.
            </p>
            <button onClick={() => setDeleteAccountOpen(true)} className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 transition-colors" data-id="element-452" data-mp="13z48i0kb6p9k">
              Delete My Account
            </button>
          </div>
        </div>
      </div>
      {/* Modals */}
      <EditProfileModal isOpen={editProfileOpen} onClose={() => setEditProfileOpen(false)} userInfo={userInfo} data-id="element-453" data-mp="cw91bgpwlrl6" />
      <ChangePasswordModal isOpen={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} data-id="element-454" data-mp="lwfcgvy4qfh6" />
      <DeleteAccountModal isOpen={deleteAccountOpen} onClose={() => setDeleteAccountOpen(false)} data-id="element-455" data-mp="hukbjsk4243x" />
    </div>;
}